// systemName should register system in https://silence.nioint.com
import { EventTracker } from './tracker';
import { SYSTEM_NAME, TRACKER_EVENTS } from '@/config/report';
const Actions = {};
const tracker = new EventTracker(SYSTEM_NAME);

TRACKER_EVENTS.forEach(item => {
    Actions[item.action] = data => {
        const custom = { ...item.custom(), ...data };
        tracker.collectPlus({ key: item.key, custom });
    };
});

const trackers = {
    collect: (key, custom) => tracker.collect({ key, custom }),
    collectPlus: (key, custom) => tracker.collectPlus({ key, custom }),
    ...Actions
};
export default trackers;



// WEBPACK FOOTER //
// ./src/util/report/tracker/index.js